<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span 2
      h1 Atención humanizada
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-12
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema2/img1.jpg" alt="Imagen decorativa")
    p.mb-0 En el ámbito de la salud, la atención humanizada constituye un enfoque esencial para garantizar un cuidado integral, seguro y de calidad. Reconoce que la práctica sanitaria no se limita a la aplicación de conocimientos técnicos o clínicos, sino que involucra habilidades personales y sociales como el trabajo en equipo, el liderazgo y la empatía, fundamentales para establecer relaciones terapéuticas efectivas. La atención humanizada sitúa a la persona como eje del proceso de cuidado, considerando su dignidad, emociones, contexto social y red de apoyo. En este marco, el sentido de vida del personal de la salud cobra relevancia, ya que orienta su vocación, fortalece el compromiso ético y favorece interacciones respetuosas y conscientes con las personas atendidas y con la organización, sentando las bases para una gestión y un modelo de atención centrados en la persona.
    separador
    #t_2_1.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  2.1	Sentido de vida
    p.mb-4 Las relaciones personales, el autorreconocimiento y las aptitudes individuales se encuentran estrechamente vinculadas con la forma en que las personas interactúan en los diferentes contextos de la vida, especialmente en el ámbito de la atención en salud. La manera en que cada individuo se comprende a sí mismo influye directamente en la calidad de sus relaciones y en la forma como se relaciona con los demás.
    
    .bloque-texto-g.color-primario.p-3.p-sm-4.p-md-5.mb-5
      .bloque-texto-g__img(
        :style="{'background-image':`url(${require('@/assets/curso/temas/tema2/img2.jpg')})`}"
      )
      .bloque-texto-g__texto.p-4
        p.mb-0 El autoconocimiento, entendido como una herramienta para gestionar metas personales e institucionales, está estrechamente ligado al sentido a la vida que cada persona construye. Este corresponde al propósito que cada ser humano define para su existencia y es plenamente armonizable con la vocación, el carisma del quehacer y la disciplina que el personal de la salud desempeña en su práctica cotidiana. Reconocer, definir y comprender el propio propósito de vida potencia la capacidad de identificarse con los objetivos, metas y sueños personales, y facilita, a su vez, el reconocimiento de los demás desde criterios de respeto y comprensión.
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-7.order-2.order-lg-1
        p Cuando el sentido a la vida se alinea con el rol o la labor desempeñada diariamente, aumenta la posibilidad de establecer metas comunes, trabajar por el bienestar propio y colectivo, y generar impactos positivos y significativos. En el ámbito de la atención en salud, este aspecto cobra especial relevancia, ya que el bienestar del personal se traduce directamente en el bienestar de las personas atendidas, dada la naturaleza de una labor orientada al servicio y al cuidado de la vida. Por ello, el respeto y la dignidad humana deben constituirse en pilares fundamentales del proyecto de vida personal, profesional y familiar del personal de la salud.
        .cajon.color-secundario.p-4.mb-4
          p.mb-0 El sentido a la vida encuentra su fundamento en la necesidad que tiene cada persona de otorgar significado a su propia existencia. No es la vida la que proporciona ese significado de manera automática, sino que cada individuo enfrenta el desafío de construirlo a partir de sus decisiones, acciones y experiencias.
      .col-lg-3.col-8.order-1.order-lg-2
        figure.mb-4(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema2/img3.jpg" alt="Imagen decorativa")

    .row.justify-content-center.align-items-center.mb-4
      .col-lg-4.col-6.mb-4.mb-lg-0
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema2/img4.jpg" alt="Icono 1")
      .col-lg-8.mb-4.mb-lg-0
        .row.justify-content-center.mb-3
          .col-lg-2.d-none.d-lg-block
            figure(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema2/img5.svg" alt="Icono 1"  class="m-auto" style="width: 100px;")
          .col-lg-10
            p.mb-0(data-aos="fade-left") Las decisiones y acciones que se adoptan a lo largo de la vida configuran y revelan el sentido que se le otorga a la existencia. La vida interpela, cuestiona y desafía constantemente a las personas, invitándolas a responder de manera consciente y responsable.
        p(data-aos="fade-left") Finalmente, el sentido que se atribuye a las acciones y a los planes personales permite orientar la comprensión de la razón de existir y del propósito de vida. Este proceso forma parte esencial del crecimiento personal y profesional, especialmente en quienes desempeñan labores de cuidado, y constituye un elemento clave para fortalecer una atención en salud verdaderamente humanizada.
        p.mb-0(data-aos="fade-left") Con base en lo anterior, el sentido a la vida orienta acciones y procesos personales y profesionales que fortalecen la atención humanizada en salud, como son:

    .tarjeta--BMG4.p-5
      .tarjeta.tarjeta--gris.p-4
        PasosB.color-acento-contenido
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema2/img6.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Autoconocimiento
              p.mb-0 Hace referencia a la capacidad de reconocer las propias emociones, valores, fortalezas, limitaciones y motivaciones. En el personal de la salud, este proceso permite actuar de manera consciente, regular las emociones en situaciones complejas y alinear el ejercicio profesional con principios éticos y humanos.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema2/img7.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Propósito de vida
              p.mb-0 Corresponde a la razón que orienta las decisiones y proyectos personales y profesionales. En la atención en salud, este propósito se vincula estrechamente con la vocación de servicio y el compromiso con el cuidado de la vida, favoreciendo prácticas responsables, empáticas y centradas en la persona.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema2/img8.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Vocación de servicio
              p.mb-0 Se entiende como la disposición interna para atender y cuidar a otros con responsabilidad, respeto y sensibilidad. En el contexto sanitario, esta vocación fortalece la atención humanizada, promoviendo relaciones basadas en la dignidad humana y el reconocimiento del otro como un ser integral.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema2/img9.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Valores personales y éticos
              p.mb-0 Orientan la conducta y la toma de decisiones en la vida cotidiana y profesional. En el ámbito de la salud, valores como el respeto, la solidaridad, la responsabilidad y la empatía son fundamentales para garantizar una atención segura, justa y humanizada.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema2/img10.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Bienestar personal
              p.mb-0 Comprende el equilibrio físico, emocional, social y espiritual de cada individuo. Para el personal de la salud, cuidar el propio bienestar es una condición necesaria para ofrecer una atención de calidad, ya que el autocuidado impacta directamente en la relación con las personas atendidas y en el trabajo en equipo.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema2/img11.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Proyecto de vida
              p.mb-0 Integra las metas, sueños y aspiraciones personales y profesionales. En el campo de la salud, este proyecto se construye de manera articulada con el sentido a la vida, permitiendo orientar el crecimiento personal, el desarrollo profesional y la contribución al bienestar colectivo.

    separador
    #t_2_2.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  2.2	Relación interpersonal (personal de la salud - persona y su red de apoyo - organización)
    
    p.mb-4 Desde el enfoque de la humanización, se reconoce la importancia de las relaciones interpersonales, las cuales se establecen entre personas o grupos de personas. Estas relaciones permiten el intercambio de información, la comunicación efectiva, la expresión de emociones, la toma de decisiones compartidas y la puesta en práctica de acciones orientadas a ayudar y servir a otros, lo cual constituye el quehacer cotidiano de la atención humanizada en salud.
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        .cajon.color-primario.p-4.mb-4
          .row.justify-content-center.align-items-center
            .col-lg-2.d-none.d-lg-block
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema2/img12.svg" alt="Icono 1")
            .col-lg-10
              p.mb-0 La interacción interpersonal entre el talento humano en salud, la persona sujeto de cuidado, su red de apoyo y la organización, se convierte en un elemento esencial para brindar una atención humanizada, basada en el respeto, la empatía y la dignidad humana.

    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        p.mb-0 Para establecer relaciones interpersonales asertivas, se pueden identificar 3 aspectos principales:
    
    .row.justify-content-center.mb-5
      .col-12.movil.mb-4
        .tarjeta.tarjeta--BG04.p-4
          figure.mb-4
              img(src="@/assets/curso/temas/tema2/img13.jpg", alt="alt")
          h4.mb-3 Objetividad
          p.mb-0 Es la capacidad de salirse de sí mismo y alcanzar puntos en común con la otra persona.
      .col-xl-4.col-lg-7.col-md-9.col-11.mb-4.mb-xl-0.desktop
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(src="@/assets/curso/temas/tema2/img13.jpg", alt="alt")
          .crd_hover_txt--body
            .tit-tarj.p-3
              .ubicar
                .acordion__accion.acordion__accion__btn--b.h3.mb-0
                  i.fas.fa-angle-up
                h4.mb-3 Objetividad
            p.mt-3.px-4 Es la capacidad de salirse de sí mismo y alcanzar puntos en común con la otra persona.
      .col-12.movil.mb-4
        .tarjeta.tarjeta--BG04.p-4
          figure.mb-4
              img(src="@/assets/curso/temas/tema2/img14.jpg", alt="alt")
          h4.mb-3 Respeto
          p.mb-0 Es el reconocimiento del otro.

      .col-xl-4.col-lg-7.col-md-9.col-11.mb-4.mb-xl-0.desktop
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(src="@/assets/curso/temas/tema2/img14.jpg", alt="alt")
          .crd_hover_txt--body
            .tit-tarj.p-3
              .ubicar
                .acordion__accion.acordion__accion__btn--b.h3.mb-0
                  i.fas.fa-angle-up
                h4.mb-3 Respeto
            p.mt-3.px-4 Es el reconocimiento del otro.
      
      .col-12.movil
        .tarjeta.tarjeta--BG04.p-4
          figure.mb-4
              img(src="@/assets/curso/temas/tema2/img15.jpg", alt="alt")
          h4.mb-3 Tolerancia
          p.mb-0 Es la capacidad de entender pensamientos y acciones estando en desacuerdo.

      .col-xl-4.col-lg-7.col-md-9.col-11.mb-4.mb-xl-0.desktop
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(src="@/assets/curso/temas/tema2/img15.jpg", alt="alt")
          .crd_hover_txt--body
            .tit-tarj.p-3
              .ubicar
                .acordion__accion.acordion__accion__btn--b.h3.mb-0
                  i.fas.fa-angle-up
                h4.mb-3 Tolerancia
            p.mt-3.px-4 Es la capacidad de entender pensamientos y acciones estando en desacuerdo.
    p.mb-4 Asimismo, se pueden considerar las siguientes aptitudes que favorecen las relaciones interpersonales entre el paciente y familia, el personal de salud y las organizaciones:
    
    .row.justify-content-center.align-items-center.mb-5
      .col-lg-5.order-2.order-lg-1
        LineaTiempoD.color-acento-botones
          p(numero="1" titulo="Confianza")  En muchos encuentros iniciales pueden surgir dudas o desconfianza; esta aptitud promueve la disposición a creer en el otro, facilitando relaciones basadas en la seguridad, el respeto y la apertura.
          p(numero="2" titulo="Aceptación") Implica la capacidad de escuchar activamente y reconocer el conocimiento, la experiencia y la experticia de la otra persona, valorando su aporte en la interacción.
          p(numero="3" titulo="Igualdad") Permite comprender que, más allá de las diferencias étnicas, etarias, culturales, religiosas o socioeconómicas, todas las personas deben ser reconocidas desde su dignidad, favoreciendo escenarios de diálogo respetuoso.
          p(numero="4" titulo="Empatía")  Es una aptitud transversal al comportamiento humano que posibilita comprender la realidad del otro, considerando sus emociones y experiencias, lo que fortalece la relación interpersonal y genera satisfacción mutua.
          p(numero="5" titulo="Espontaneidad")  La autenticidad y la naturalidad son esenciales en las relaciones interpersonales; esta aptitud permite actuar con agrado y coherencia, respetando la autonomía y la libertad del otro.
          p(numero="6" titulo="Flexibilidad") Refleja la capacidad de adaptación y tolerancia en el trato interpersonal, facilitando la convivencia en diversos entornos y promoviendo la apertura al diálogo, la concertación y el reconocimiento de distintas formas de pensar.
      .col-lg-5.col-6.mb-4.mb-lg-0.order-1.order-lg-2
        figure
          img(src="@/assets/curso/temas/tema2/img16.jpg", alt="alt")
    p.mb-4 Estas aptitudes posibilitan el desarrollo de una actitud de humanización, la cual permite confrontar las dificultades que se pueden presentar en las relaciones interpersonales (por ejemplo, el conflicto) y convertirlas en oportunidades de aprendizaje, manteniendo la capacidad de apoyo y servicio.
    .tarjeta--BG04.p-4
      .row.justify-content-center.align-items-center.mb-5
        .col-lg-3
          figure
            img(src="@/assets/curso/temas/tema2/img17.svg", alt="alt")

        .col-lg-7
          .titulo-segundo.color-acento-contenido
            h5 Humanización en salud Covid-19
          p Para complementar las habilidades para la atención humanizada, se recomienda revisar esta charla sobre humanización de los servicios de salud en tiempos de pandemia del Covid-19, a cargo de la Dra. Carol Bernal, Fonoaudióloga, Magíster en Discapacidad e Inclusión Social, candidata a doctora Salud Pública y Secretaria General de la Asociación Colombiana de Salud Pública.
          a.boton.color-acento-botones(:href="('https://www.youtube.com/watch?v=rS6HN01ZY8Y')" target="_blank" type="application/pdf")
            span Abrir video
            i.fas.fa-file-download

</template>

<script>
export default {
  name: 'Tema2',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
